/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Drastic_Tech_Debug_Logging_AriaInputs */



/**
* | output |
* | --- |
* | "Debug Logging" |
*
* @param {Drastic_Tech_Debug_Logging_AriaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const drastic_tech_debug_logging_aria = /** @type {((inputs?: Drastic_Tech_Debug_Logging_AriaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Drastic_Tech_Debug_Logging_AriaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Journal de debogage")
	if (locale === "de") return /** @type {LocalizedString} */ ("Debug-Protokollierung")
	if (locale === "it") return /** @type {LocalizedString} */ ("Registrazione di debug")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Ведение отладочного журнала")
	if (locale === "es") return /** @type {LocalizedString} */ ("Registro de depuración")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("调试日志")
	if (locale === "ja") return /** @type {LocalizedString} */ ("デバッグログ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("लॉगिंग डीबग करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Registro de depuração")
	return /** @type {LocalizedString} */ ("Debug Logging")
});